// extracted by mini-css-extract-plugin
module.exports = {"thumbDark":"NavbarBottom_thumbDark__AhLyj","thumbLight":"NavbarBottom_thumbLight__4yQ4e"};